import { PureComponent } from "react";
import { StyledCompetitorsComparisonTableComponent } from "./competitors-comparison-table-component.scss";
import Picture from "/components/core/picture/picture-component";
import ComparisonFeatureComponent from "./comparison-feature/comparison-feature-component";

export default class CompetitorsComparisonTableComponent extends PureComponent {
  render() {
    const { title, subtitle, features, mondayLogo, competitorLogo } = this.props;
    return (
      <StyledCompetitorsComparisonTableComponent className="competitors-comparison-table">
        <div className="competitors-comparison-titles-wrapper">
          <div className="competitors-comparison-title">{title}</div>
          <div className="competitors-comparison-subtitle">{subtitle}</div>
        </div>
        <div className="table-wrapper">
          <div className="table-row table-header">
            <div className="table-cell" />
            <div className="table-cell">
              <div className="monday-logo-wrapper" style={{ height: `${mondayLogo.height}%` }}>
                <Picture className="monday-logo" src="/static/img/monday-logos/monday_logo_short.png" />
              </div>
            </div>
            <div className="table-cell vs-cell">vs.</div>
            <div className="table-cell">
              {competitorLogo && (
                <div className="competitor-logo-wrapper" style={{ height: `${competitorLogo.height}%` }}>
                  <Picture className="competitor-logo" src={competitorLogo.src} />
                </div>
              )}
            </div>
            <div className="table-cell" />
          </div>

          {features.map((feature, i) => {
            return <ComparisonFeatureComponent key={i} {...feature.props} index={i} />;
          })}
        </div>

        <div className="mobile-table-wrapper">
          <div className="table-header">
            <div className="table-cell">
              <div className="monday-logo-wrapper" style={{ height: `${mondayLogo.height}%` }}>
                <Picture className="monday-logo" src="/static/img/monday-logos/monday_logo_short.png" />
              </div>
            </div>
            <div className="table-cell">
              {competitorLogo && (
                <div className="competitor-logo-wrapper" style={{ height: `${competitorLogo.height}%` }}>
                  <Picture className="competitor-logo" src={competitorLogo.src} />
                </div>
              )}
            </div>
          </div>
          {features.map((feature, i) => {
            return <ComparisonFeatureComponent key={i} {...feature.props} index={i} />;
          })}
        </div>
      </StyledCompetitorsComparisonTableComponent>
    );
  }
}

CompetitorsComparisonTableComponent.defaultProps = {
  features: [],
  mondayLogo: {}
};
